import { render, staticRenderFns } from "./OrderPayFailIframe.vue?vue&type=template&id=86ba5f0c&"
import script from "./OrderPayFailIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderPayFailIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports